import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { NewPlanPage } from '../../../../features/commissions/plan-page'

export const Route = createFileRoute('/_app/commissions/plans/new')({
  staticData: { crumb: 'commissionPlanNew' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'commissions.manage'),
  component: NewPlanPage,
})
